<template>
    <span class="poi-address" :aria-busy="loading ? 'true' : 'false'">
        <text-skeleton v-if="loading" :lines="2" />
        <template v-else>{{ poi.address || '-' }}</template>
    </span>
</template>

<script>
import TextSkeleton from '@/components/commons/TextSkeleton.vue'

export default {
    name: 'PoiAddress',
    components: { TextSkeleton },
    props: {
        poi: {
            type: Object,
            required: true
        },
        skeletonMinDuration: {
            type: Number,
            default: 1000,
            validator: (value) => value >= 0
        }
    },
    data() {
        return {
            loading: false,
            loadingStartedAt: 0,
            loadingTimer: null,
            requestId: 0
        }
    },
    computed: {
        coordinateKey() {
            return `${this.poi.id}:${this.poi.lat}:${this.poi.lng}`
        },
        hasValidCoordinates() {
            const lat = Number(this.poi.lat)
            const lng = Number(this.poi.lng)
            const present =
                this.poi.lat !== null &&
                this.poi.lat !== undefined &&
                this.poi.lat !== '' &&
                this.poi.lng !== null &&
                this.poi.lng !== undefined &&
                this.poi.lng !== ''

            return (
                present &&
                Number.isFinite(lat) &&
                Number.isFinite(lng) &&
                lat >= -90 &&
                lat <= 90 &&
                lng >= -180 &&
                lng <= 180
            )
        }
    },
    watch: {
        coordinateKey: {
            immediate: true,
            handler() {
                this.resolveAddress()
            }
        }
    },
    methods: {
        async resolveAddress() {
            clearTimeout(this.loadingTimer)
            this.loadingTimer = null

            const requestId = ++this.requestId
            if (this.poi.address || !this.hasValidCoordinates) {
                this.loading = false
                return
            }

            this.loading = true
            this.loadingStartedAt = Date.now()
            try {
                await this.$store.dispatch('loadPoiAddress', {
                    vueInstance: this,
                    poi: this.poi
                })
            } catch (error) {
                // The row remains usable even if reverse geocoding is unavailable.
            } finally {
                if (requestId === this.requestId && !this._isDestroyed) {
                    const remaining =
                        this.skeletonMinDuration - (Date.now() - this.loadingStartedAt)

                    if (remaining > 0) {
                        this.loadingTimer = setTimeout(() => {
                            if (requestId === this.requestId && !this._isDestroyed) {
                                this.loading = false
                            }
                        }, remaining)
                    } else {
                        this.loading = false
                    }
                }
            }
        }
    },
    beforeDestroy() {
        clearTimeout(this.loadingTimer)
        this.requestId++
    }
}
</script>

<style scoped>
.poi-address {
    display: inline-block;
    width: 100%;
}
</style>
